import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { useAuth } from "provider/AuthContext";
import MessageProvider, { useMessageContext } from "provider/MessageProvider";
import React, { useEffect, useRef } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import Quatation from "./quotation/Quatation";
import ChatMessages from "./quotation/ChatMessages";
import MessageForm from "./forms/MessageForm";
import ActiveUser from "./common/ActiveUser";
import DirectContacts from "./direct/DirectContacts";
import QuotationChatModal from "./quotation/QuotationChatModal";
import { useScreenSize } from "provider/ScreenSizeProvider";


function Messages() {

  return (
    <MessageProvider>
      <MessageContent />
    </MessageProvider>
  );
}
const MessageContent = () => {
  const { logout, userProfile } = useAuth();
  const navigate = useNavigate();
  //check user type (allowed only for normal user)
  if (userProfile?.is_safari_operator) {
    navigate('/')
  }
  const { isMobileView } = useScreenSize();

  const prevUrlRef = useRef();

  const { dcPageIndex,
    qcPageIndex, quotationContact, directContact, activeUser,
    activeTab, newMessageAdded, toggleChatContact,
    messageDispatch } = useMessageContext();



  // Fetch Direct Chat contacts
  useEffect(() => {
    const fetchDirectContacts = async () => {
      try {
        messageDispatch({ type: `DC_CONTACT_LOADING`, payload: true });

        const response = await apiCall({ url: "chat/user-list?pageSize=50", method: "GET" });
        if (response.status !== 200) {
          const error = new Error(`Unexpected status: ${response.status}`);
          error.status = response.status;
          error.response = response;
          throw error;
        }

        const apiData = response.data;

        if (apiData?.errors) {
          messageDispatch({ type: `SET_DC_CONTACT_ERROR`, payload: apiData.errors });
          return;
        }

        const data = apiData?.contcats?.data || [];
        const summary = apiData?.contcats?.summary;



        messageDispatch({
          type: dcPageIndex === 1 ? `SET_DIRECT_CONTACT_DATA` : `APPEND_DIRECT_CONTACT_DATA`,
          payload: data,
        });
        if (data.length > 0) {
          messageDispatch({ type: `SET_ACTIVE_USER`, payload: data[0] });
        }
        messageDispatch({
          type: `DC_SUMMARY`,
          payload: {
            total: summary?.total,
            page: summary?.page,
            pageSize: summary?.pageSize,
            total_page: summary?.total_page,
          },
        });
      } catch (error) {
        console.error("DC contact fetch error:", error);
        messageDispatch({
          type: `SET_DC_CONTACT_ERROR`,
          payload: "Network or server error occurred.",
        });
        handleError(error, logout, navigate);
      } finally {
        messageDispatch({ type: `DC_CONTACT_LOADING`, payload: false });
      }
    };

    fetchDirectContacts();
  }, [dcPageIndex]);

  // Fetch Quotation Chat contacts
  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        messageDispatch({ type: `QC_CONTACT_LOADING`, payload: true });

        const response = await apiCall({ url: "chat/quatation-chat?pageSize=50", method: "GET" });
        if (response.status !== 200) throw new Error(`Unexpected status: ${response.status}`);

        const apiData = response.data;

        if (apiData?.errors) {
          messageDispatch({ type: `SET_QC_CONTACT_ERROR`, payload: apiData.errors });
          return;
        }

        const data = apiData?.quotations?.data || [];
        const summary = apiData?.quotations?.summary;


        messageDispatch({
          type: qcPageIndex === 1 ? `SET_QUATATION_CONTACT_DATA` : `APPEND_QUATATION_CONTACT_DATA`,
          payload: data,
        });

        messageDispatch({
          type: `QC_SUMMARY`,
          payload: {
            total: summary?.total,
            page: summary?.page,
            pageSize: summary?.pageSize,
            total_page: summary?.total_page,
          },
        });
      } catch (error) {
        console.error("QC contact fetch error:", error);
        messageDispatch({
          type: `SET_QC_CONTACT_ERROR`,
          payload: "Network or server error occurred.",
        });
        handleError(error, logout, navigate);
      } finally {
        messageDispatch({ type: `QC_CONTACT_LOADING`, payload: false });
      }
    };

    fetchQuotation();
  }, [qcPageIndex]);

  //Get Active User Messages
  useEffect(() => {
    if (!activeUser?.chat_hash) return;

    const fetchMessages = async () => {
      try {
        messageDispatch({ type: "MSG_LOADING", payload: true });

        let currentPage = 1;
        let totalPages = 1;
        let allMessages = [];

        do {
          const response = await apiCall({
            url: `chat/messages/${activeUser.chat_hash}?page=${currentPage}`,
            method: "GET",
          });

          if (response.status !== 200) throw new Error(`Unexpected status: ${response.status}`);
          const apiData = response.data;

          if (apiData?.errors) {
            messageDispatch({ type: "SET_MESSAGE_ERROR", payload: apiData.errors });
            return;
          }

          const pageData = apiData?.chat_messages?.data || [];
          allMessages = [...pageData, ...allMessages];

          const summary = apiData?.chat_messages?.summary || {};
          totalPages = summary.total_page || 1;

          // Save summary only once (on first page)
          if (currentPage === 1) {
            messageDispatch({
              type: "MESSAGE_SUMMARY",
              payload: {
                total: summary.total,
                page: summary.page,
                pageSize: summary.pageSize,
                total_page: totalPages,
              },
            });
          }

          currentPage++;
        } while (currentPage <= Math.min(3, totalPages));

        // Set all fetched messages at once
        messageDispatch({
          type: "SET_MESSAGES_DATA",
          payload: allMessages,
        });
        messageDispatch({
          type: "MESSAGE_PAGE_INDEX",
          payload: currentPage - 1,
        });
        messageDispatch({
          type: "MESSAGE_INITIAL_PAGE_INDEX",
          payload: currentPage - 1,
        });

      } catch (error) {
        console.error("Message fetch error:", error);
        messageDispatch({
          type: "SET_MESSAGE_ERROR",
          payload: "Network or server error occurred.",
        });
        handleError(error, logout, navigate);
      } finally {
        messageDispatch({ type: "MSG_LOADING", payload: false });
      }
    };

    fetchMessages();
  }, [activeUser?.chat_hash]);
  //set active user based on active Tab Direct Conatct / Quotation Contact
  useEffect(() => {
    if (newMessageAdded) return;

    const hasDirectContacts = directContact && directContact.length > 0;
    const hasQuotationContacts = quotationContact && quotationContact.length > 0;

    let firstContact = null;

    if (activeTab === 'direct-messages' && hasDirectContacts) {
      firstContact = directContact[0];
    } else if (activeTab === 'quote-requests' && hasQuotationContacts) {
      firstContact = quotationContact[0];
    }

    if (firstContact) {
      messageDispatch({ type: 'SET_ACTIVE_USER', payload: firstContact });
    } else {
      // Optional: clear the active user if no contacts exist
      messageDispatch({ type: 'SET_ACTIVE_USER', payload: {} });
    }
  }, [activeTab, quotationContact, directContact]);


  useEffect(() => {
    if (!userProfile?.operator_slug || userProfile.operator_slug.length === 0) return;
    const currentUrl = `operator/${userProfile?.operator_slug}/operator-park-dropdown?pageSize=12`
    const opertaorParks = async () => {

      try {
        const response = await apiCall({
          url: currentUrl,
        });

        if (response.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            console.error(errors)
          } else {
            const parksOptions = response?.data?.parks?.data || [];
            const options = parksOptions?.map((item) => ({
              label: item.title,
              value: item.id,
            }));
            messageDispatch({
              type: "SET_OPERATOR_PARK_OPTIONS_CHAT_DATA",
              payload: options,
            });
          }
        }
      } catch (error) {
        // console.error("An error occurred while fetching user profile:", error);
        handleError(error, logout, navigate);
      } finally {

      }
    };
    if (currentUrl && currentUrl !== prevUrlRef.current) {
      prevUrlRef.current = currentUrl;
      opertaorParks();
    }
  }, [userProfile?.operator_slug]);


  const handleTabSelect = (key) => {
    messageDispatch({
      type: "SET_ACTIVE_TAB_MESSAGE",
      payload: key
    });
  };

  useEffect(() => {
    if (!isMobileView) {
      messageDispatch({ type: `TOGGLE_CHAT_CONTACT`, payload: false });
    }

  }, [isMobileView])


  return (
    <Container fluid="lg" className="mt-5 margin_bottomfooter-chat pt-5">
      <Row className="mb-5">
        <Col md={12}>
          <h6 className="fs-3 fw-bold">Message</h6>
        </Col>

        <Col md={12}>
          <Row className="itenary_tabs">
            {!isMobileView ?
              <>
                <Col xs={12} sm={12} md={4} xl={4} xxl={3} className="mb-3">
                  <div
                    className="chat-card-sidebar card"
                    style={{
                      borderRadius: "10px",
                      maxHeight: "92vh",
                      overflow: "hidden",
                      height: "88vh",
                    }}
                  >
                    <div className="card-body">
                      <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                        <div className="tablmassage safartabs">
                          <div className="overflow-auto w-100 hide-scrollbar">
                            <Nav variant="tabs" className="slider_profilemobilechatd-flex gap-2 flex-nowrap">
                              <Nav.Item>
                                <Nav.Link
                                  eventKey="direct-messages"
                                  className="chatFonts"
                                >
                                  Direct Messages
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link
                                  eventKey="quote-requests"
                                  className="chatFonts"
                                >
                                  Quote Request ({quotationContact?.length || 0})
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </div>
                        </div>

                        <Tab.Content className="mt-4">
                          <Tab.Pane eventKey="direct-messages">
                            {/* <div className="chat-search-user mb-3 position-relative">
                          <input
                            type="text"
                            className="form-control searchChat"
                            placeholder="Search"
                            autoComplete="off"
                          />
                          <div className="secrchIcons">
                            <i className="fa-solid fa-magnifying-glass"></i>
                          </div>
                        </div> */}
                            <div className="" style={{ position: "relative" }}>
                              {/* <SearchOptions /> */}
                              <DirectContacts />
                            </div>
                          </Tab.Pane>

                          <Tab.Pane eventKey="quote-requests">
                            <div className="" style={{ position: "relative" }}>
                              <Quatation />
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={8} xl={8} xxl={9} className="d-md-block  mb-3 ">
                  <div className="chat_box card h-100">
                    <div className="card-body">
                      {activeUser?.contact ? (
                        <ActiveUser user={activeUser?.contact} />
                      ) : (
                        <div className="pb-4 border-bottom">
                          Select a user to start chatting
                        </div>
                      )}
                      <ChatMessages />
                      {!userProfile?.is_safari_operator && <MessageForm />}
                    </div>
                  </div>
                </Col>
              </>
              :
              <>
                {!toggleChatContact ? <Col xs={12} sm={12} md={12} xl={4} xxl={3} className="mb-3">
                  <div
                    className="chat-card-sidebar card"
                    style={{
                      borderRadius: "10px",
                      maxHeight: "92vh",
                      overflow: "hidden",
                      height: "88vh",
                    }}
                  >
                    <div className="card-body">
                      <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                        <div className="tablmassage safartabs">
                          <div className="overflow-auto w-100 hide-scrollbar">
                            <Nav variant="tabs" className="slider_profilemobilechatd-flex gap-2 flex-nowrap">
                              <Nav.Item>
                                <Nav.Link
                                  eventKey="direct-messages"
                                  className="chatFonts"
                                >
                                  Direct Messages
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link
                                  eventKey="quote-requests"
                                  className="chatFonts"
                                >
                                  Quote Request ({quotationContact?.length || 0})
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </div>
                        </div>

                        <Tab.Content className="mt-4">
                          <Tab.Pane eventKey="direct-messages">
                            {/* <div className="chat-search-user mb-3 position-relative">
                          <input
                            type="text"
                            className="form-control searchChat"
                            placeholder="Search"
                            autoComplete="off"
                          />
                          <div className="secrchIcons">
                            <i className="fa-solid fa-magnifying-glass"></i>
                          </div>
                        </div> */}

                            {/* <SearchOptions /> */}
                            <DirectContacts />
                          </Tab.Pane>

                          <Tab.Pane eventKey="quote-requests">
                            <div className="chat-cardlist">
                              <Quatation />
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </Col>
                  :
                  <Col xs={12} sm={12} md={12} xl={8} xxl={9} className="d-md-block mb-3 ">
                    <div className="chat_box card h-100">
                      <div className="card-body">
                        {activeUser?.contact ? (
                          <ActiveUser user={activeUser?.contact} />
                        ) : (
                          <div className="pb-4 border-bottom">
                            Select a user to start chatting
                          </div>
                        )}
                        <ChatMessages />
                        <MessageForm />
                      </div>
                    </div>
                  </Col>
                }
              </>
            }
          </Row>
        </Col>
      </Row>
      <QuotationChatModal />
    </Container>
  )
}


export default Messages;
